import axios from 'axios';

const api = (method) => process.env.VUE_APP_API_URL + method;

const unwrap = (request) => request
  .then((response) => response.data)
  .catch((error) => { console.log(error); });

const post = (method, body = {}) => axios.post(api(method), body);

export default {
  async Login(credentials) {
    return await unwrap(post('UserLogin', {
      UserEmail: credentials.email,
      UserPassword: credentials.password,
    }));
  },
  async Logout(sessionUserID, sessionHash) {
    return await unwrap(post('UserLogout', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
    }));
  },
  async Registration(credentials) {
    return await unwrap(post('UserRegistration', {
      UserNickName: credentials.username,
      UserEmail: credentials.email,
      UserPhone: credentials.phone,
    }));
  },
  async GetRegistration(registrationToken) {
    return await unwrap(post('GetRegistration', {
      RegistrationToken: registrationToken,
    }));
  },
  async UserRegConfirm(credentials, registrationToken) {
    return await unwrap(post('UserRegConfirm', {
      RegistrationToken: registrationToken,
      UserFirstName: credentials.firstname,
      UserLastName: credentials.lastname,
      UserEmailConfirmCode: credentials.emailCode,
      UserPhoneConfirmCode: credentials.smsCode,
      UserImage: credentials.profileImg,
      UserPassword: credentials.password,
      UserPassword2: credentials.confirmPassword,
    }));
  },
  async UserPasswordChange(sessionUserID, sessionHash, credentials) {
    return await unwrap(post('UserPasswordChange', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      UserPasswordCurrent: credentials.currentPassword,
      UserPassword: credentials.newPassword,
      UserPassword2: credentials.confirmPassword,
    }));
  },
  async UserPasswordReset(email) {
    return await unwrap(post('UserPasswordReset', {
      UserEmail: email,
    }));
  },
  async UserImageChange(sessionUserID, sessionHash, userImage) {
    return await unwrap(post('UserImageChange', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      UserImage: userImage,
    }));
  },
  async GetUserObsolete(sessionUserID, sessionHash) {
    return await unwrap(post('GetUserObsolete', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
    }));
  },
  async UserObsolete(sessionUserID, sessionHash, password, reason) {
    return await unwrap(post('UserObsolete', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      UserPassword: password,
      UserObsoleteReason: reason,
    }));
  },
};
